import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import router from './router'
import Breadcrumbs from './components/bread_crumbs'
import { store } from './store'
import VueFeather from 'vue-feather'
import {Directus} from "@directus/sdk";
import Toasted from 'vue-toasted';
import SweetAlert from 'vue-sweetalert2';
import axios from "axios";


window.localStorage.removeItem('directus-sdk-js');

//directus 

const dConfig = {
  auth: {
    mode:"json",
    autorefresh: true,
    msRefreshBeforeExpires: 30000
  },
  storage: {
    mode: 'LocalStorage'
  }
}

const dUrl = "https://" + process.env.VUE_APP_API_HOST;

const directus = new Directus(dUrl, dConfig);

Object.defineProperties(Vue.prototype, {
  $directus: { value: directus }
});


/*
const directus = new Directus({
  url: "https://" + process.env.VUE_APP_API_HOST + "/public",
  project: process.env.VUE_APP_API_PROJECT,
  storage: window.localStorage,
  persist: true,
  tokenExpirationTime: 5 * 60 * 1000,
});
*/



// Import Theme scss
import './assets/scss/app.scss'
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueFeather);
Vue.use(BootstrapVue);
Vue.component('Breadcrumbs', Breadcrumbs);
Vue.use(Toasted);
Vue.use(SweetAlert);


Vue.mixin({
  methods: {
    transformDate: function (date, mode = "complete") {
      const dateObj = new Date(date);
      if (mode == "complete") return dateObj.toLocaleDateString() + " " + dateObj.toLocaleTimeString();
      if (mode == "date") return dateObj.toLocaleDateString();
    },
    cloneNonReactive: function (obj) { return JSON.parse(JSON.stringify(obj)) },
    displayNumberDots: function (number) { return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") },
    displayCurrency: function (num) { 
      if(num == null) return;
      let string = typeof num != "string" ? string = num.toString() : num;

      const result = string.replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " €"; 
      
      return result;
    },
    displayQm: function (number) { return number + "m<sup>2</sup>" },
    ucFirst: function (string) { return string.charAt(0).toUpperCase() + string.slice(1) },
    date_sort(a, b) {
      if (a.created_on > b.created_on) {
        return -1;
      }
      if (a.created_on < b.created_on) {
        return 1;
      }
      return 0;
    },
    chk_exists: function(obj) {
      return "undefined" !== typeof(obj);
    },
    truncate_str: function(string, length=20) {
       return string.length > length ? string.substr(0, length) + "..." : string;
    },
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')